import { Injectable } from '@angular/core';
import {
  IActualizarConfigEmpresaReq,
  IConfigEmpresaRes,
} from '@core/interfaces/request-response/empresa.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class EmpresaApiService extends BaseHttpService {
  cargarEmpresa() {
    return this.withLoader(
      this.httpClient.get<IConfigEmpresaRes>(
        `${environment.apiUrl}${environment.apiPreFix}/empresa/cargar-config`,
      ),
    );
  }
  guardar(data: Partial<IActualizarConfigEmpresaReq>) {
    return this.withLoader(
      this.httpClient.put<IConfigEmpresaRes>(
        `${environment.apiUrl}${environment.apiPreFix}/empresa/actualizar-config`,
        data,
      ),
    );
  }
}
